// ActionButtons.tsx
import React from 'react';
import { 
    Button, 
    Stack, 
    Box, 
    IconButton, // Імпортуємо IconButton
    useMediaQuery, // Імпортуємо useMediaQuery
    useTheme, // Імпортуємо useTheme
    SvgIconTypeMap 
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { useTranslation } from 'react-i18next';

// --- Конфігурація та Інтерфейси (Залишаються без змін) ---

type MuiIcon = OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string };

export interface ActionButtonProp {
  type: 'edit' | 'delete' | 'extended';
  action: () => void;
  icon?: MuiIcon,
}

interface ActionButtonsProps {
  actions: ActionButtonProp[];
}

// --- Компонент ActionButtons з умовним рендерингом ---

const ActionButtons: React.FC<ActionButtonsProps> = ({ actions }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  // isWideScreen = false!!! <- так решили
  // Визначаємо, чи екран ШИРОКИЙ (більше або дорівнює 'sm' брейкпоінту)
  const isWideScreen = false && useMediaQuery(theme.breakpoints.up('sm')); 
  // const isNarrowScreen = !isWideScreen; // Якщо потрібно, можна використовувати цю змінну

  const actionConfig: Record<string, { icon: MuiIcon, color: 'primary' | 'error' | 'info', label: string }> = {
    edit: { icon: EditIcon, color: 'primary', label: t('common.Edit') },
    delete: { icon: DeleteIcon, color: 'error', label: t('common.Delete') },
    extended: { icon: MoreHorizIcon, color: 'info', label: t('common.Details') },
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <Stack direction="row" spacing={1}>
        {actions.map((button, index) => {
          const config = actionConfig[button.type];
          if (!config) return null;

          const IconComponent = button.icon || config.icon;

          if (isWideScreen) {
            // --- ШИРОКИЙ ЕКРАН: Button з текстом та іконкою ---
            return (
              <Button
                key={index}
                onClick={button.action}
                size="small"
                color={config.color}
                variant='outlined'
                startIcon={<IconComponent fontSize="small" />}
              >
                {config.label}
              </Button>
            );
          } else {
            // --- ВУЗЬКИЙ ЕКРАН: IconButton тільки з іконкою ---
            return (
              <IconButton
                key={index}
                onClick={button.action}
                size="small"
                color={config.color}
                aria-label={config.label} // Обов'язково для доступності!
              >
                <IconComponent fontSize="small" />
              </IconButton>
            );
          }
        })}
      </Stack>
    </Box>
  );
};

export default ActionButtons;